/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Integration_OffInputs */

const vi_grower_area_camera_integration_off = /** @type {(inputs: Grower_Area_Camera_Integration_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tích hợp camera đang tắt`)
};

/**

* @param {Grower_Area_Camera_Integration_OffInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_integration_off = /** @type {((inputs?: Grower_Area_Camera_Integration_OffInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Integration_OffInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_integration_off(inputs)
});